import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import LogoutUser from "../../../../common/snippet/logOut";
import { updateRoutefunc } from "../../../../redux/classes/common/updateRoute";
import { useLocation } from "react-router-dom";
import EditIcon from "../../../../assets/icons-svg/edit.svg";
import { GetClientUserPermByIdForProvider } from "../../../../actions/provider-portal/AllUserAPIs";
import useUnauthorizedHandler from "../../../../common/snippet/useUnauthorizedHandler";
import { setPermissionData } from "../../../../redux/classes/client-portal/permissionsSlice";
// import {GetClientUserPermByIdForClient} from '../../../../actions/client-portal/AllUsersApi';
const ContractorPortalSideNav = () => {
  const handleUnauthorizedAccess = useUnauthorizedHandler();
  const storedData = JSON.parse(localStorage.getItem("LoginUserData"));
  const location = useLocation();
  const permissionProviderData = useSelector(
    (state) => state?.permissionsProvider?.permissionData
  );
  const { updateRoute } = useSelector((state) => state);
  const dispatch = useDispatch();
  const [forceRender, setForceRender] = useState(false);
  const [activeMenu, setActiveMenu] = useState("dashboard");

  useEffect(() => {
    if (permissionProviderData !== null) {
      localStorage?.setItem(
        "permission_data",
        JSON?.stringify(permissionProviderData)
      );
      setForceRender((prevForceRender) => !prevForceRender);
    }
  }, [permissionProviderData]);

  const permissionData = JSON.parse(localStorage?.getItem("permission_data"));
  let permission_data = {};

  //Check Client Permission
  if (permissionData !== null) {
    permission_data = permissionData;
  }

  // const dispatch = useDispatch();
  // const permissionData = JSON.parse(localStorage.getItem("permission_data"));
  // let permission_data;
  // // let function_assignment_id
  // // let user_id;
  // if (permissionData !== null) {
  //   permission_data = permissionData;
  // }
  // const storedData = JSON.parse(localStorage.getItem("LoginUserData"));
  // if (storedData !== null) {
  //   // user_id =  storedData?.userName?.user_id;
  //   // function_assignment_id = storedData.function_assignment_id;
  // }

  // useEffect(() =>{
  //   const apiData = {
  //     user_id: user_id,
  //     function_assignment_id: function_assignment_id
  //   }
  //   dispatch(GetClientUserPermByIdForClient(apiData)).then(
  //     (response) => {
  //        if (response.success === true) {
  //           // const arrayData = response.data;
  //           localStorage.setItem("permission_data", JSON.stringify(response.data))
  //         }
  //        }
  //   );
  // },[])

  const updateActiveStatus = (item) => {
    setActiveMenu(item);
  };

  useEffect(() => {
    if (updateRoute) {
      dispatch(updateRoutefunc(false));
      if (
        location.pathname.split("/")[2] == "users" ||
        location.pathname.split("/")[2] == "dashboard"
      ) {
        setActiveMenu("dashboard");
      } else {
        if (location.pathname.split("/")[2] == "client") {
          setActiveMenu("clients");
        }
        if (location.pathname.split("/")[2] == "documents") {
          setActiveMenu("documents");
        } else if (location.pathname.split("/")[2] == "workers") {
          setActiveMenu("workers");
        } else if (location.pathname.split("/")[2] == "messages") {
          setActiveMenu("messages");
        } else if (location.pathname.split("/")[2] == "invoices") {
          setActiveMenu("invoices");
        } else if (location.pathname.split("/")[2] == "reporting") {
          setActiveMenu("reporting");
        } else if (location.pathname.split("/")[2] == "users") {
          setActiveMenu("users");
        } else if (location.pathname.split("/")[2] == "contacts") {
          setActiveMenu("contacts");
        } else if (location.pathname.split("/")[2] == "support") {
          setActiveMenu("support");
        } else if (location.pathname.split("/")[2] == "settings") {
          setActiveMenu("settings");
        } else if (location.pathname.split("/")[2] == "notes") {
          setActiveMenu("notes");
        }
      }
    }
  }, [updateRoute, dispatch, location.pathname]);
  useEffect(() => {
    dispatch(updateRoutefunc(true));
  }, []);

  const fetchPermissionData = useCallback(() => {
    let userId = {
      user_id: storedData?.userName?.user_id,
      function_assignment_id: storedData?.function_assignment_id,
    };

    if (!userId?.user_id || !userId?.function_assignment_id) {
      return;
    }

    dispatch(GetClientUserPermByIdForProvider(userId)).then((response) => {
      if (response.success === true) {
        const arrayData = response.data;
        localStorage.setItem("permission_data", JSON.stringify(arrayData));
        permission_data = arrayData;
        dispatch(setPermissionData(arrayData));
      } else if (response.status === 401) {
        handleUnauthorizedAccess();
      } else {
      }
    });
  }, [dispatch]);

  useEffect(() => {
    fetchPermissionData();
  }, []);
  return (
    <React.Fragment>
      <div className="sideNav">
        <div className="logo-wrap">
          <span>
            <img src="/assets/icons-svg/navIcons/logo.svg" alt="" />
          </span>
        </div>
        <ul>
          <li>
            <NavLink
              to="dashboard"
              className={activeMenu == "dashboard" ? "active" : ""}
              onClick={() => updateActiveStatus("dashboard")}
            >
              <span className="icons-wrap">
                <svg
                  width="24"
                  height="25"
                  viewBox="0 0 24 25"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 6.63a1 1 0 1 0 0-2 1 1 0 0 0 0 2zM12 13.63a1 1 0 1 0 0-2 1 1 0 0 0 0 2zM12 20.63a1 1 0 1 0 0-2 1 1 0 0 0 0 2zM19 6.63a1 1 0 1 0 0-2 1 1 0 0 0 0 2zM19 13.63a1 1 0 1 0 0-2 1 1 0 0 0 0 2zM19 20.63a1 1 0 1 0 0-2 1 1 0 0 0 0 2zM5 6.63a1 1 0 1 0 0-2 1 1 0 0 0 0 2zM5 13.63a1 1 0 1 0 0-2 1 1 0 0 0 0 2zM5 20.63a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
                    stroke="#5786CC"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
              <span className="text-wrap">Dashboard</span>
            </NavLink>
          </li>

          {/* {permission_data.documents_view && (
            <li>
              <NavLink
                to="documents"
                className={activeMenu == "documents" ? "active" : ""}
                onClick={() => updateActiveStatus("documents")}
              >
                <span className="icons-wrap">
                  <svg
                    width="25"
                    height="25"
                    viewBox="0 0 25 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M21.333 8.55786V16.7579C21.333 18.438 21.333 19.2781 21.006 19.9198C20.7184 20.4843 20.2595 20.9433 19.695 21.2309C19.0532 21.5579 18.2132 21.5579 16.533 21.5579H9.13301C7.45285 21.5579 6.61277 21.5579 5.97104 21.2309C5.40655 20.9433 4.94761 20.4843 4.65999 19.9198C4.33301 19.2781 4.33301 18.438 4.33301 16.7579V8.55786M4.43301 3.55786H21.233C21.7931 3.55786 22.0731 3.55786 22.287 3.66685C22.4752 3.76273 22.6281 3.91571 22.724 4.10387C22.833 4.31778 22.833 4.59781 22.833 5.15786V6.95786C22.833 7.51791 22.833 7.79794 22.724 8.01185C22.6281 8.20001 22.4752 8.35299 22.287 8.44887C22.0731 8.55786 21.7931 8.55786 21.233 8.55786H4.43301C3.87296 8.55786 3.59293 8.55786 3.37902 8.44887C3.19086 8.35299 3.03787 8.20001 2.942 8.01185C2.83301 7.79794 2.83301 7.51791 2.83301 6.95786V5.15786C2.83301 4.59781 2.83301 4.31778 2.942 4.10387C3.03787 3.91571 3.19086 3.76273 3.37902 3.66685C3.59293 3.55786 3.87296 3.55786 4.43301 3.55786ZM10.433 12.0579H15.233C15.7931 12.0579 16.0731 12.0579 16.287 12.1669C16.4752 12.2627 16.6281 12.4157 16.724 12.6039C16.833 12.8178 16.833 13.0978 16.833 13.6579V14.4579C16.833 15.0179 16.833 15.2979 16.724 15.5119C16.6281 15.7 16.4752 15.853 16.287 15.9489C16.0731 16.0579 15.7931 16.0579 15.233 16.0579H10.433C9.87296 16.0579 9.59293 16.0579 9.37902 15.9489C9.19086 15.853 9.03787 15.7 8.942 15.5119C8.83301 15.2979 8.83301 15.0179 8.83301 14.4579V13.6579C8.83301 13.0978 8.83301 12.8178 8.942 12.6039C9.03787 12.4157 9.19086 12.2627 9.37902 12.1669C9.59293 12.0579 9.87296 12.0579 10.433 12.0579Z"
                      stroke="#5786CC"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </span>
                <span className="text-wrap">Documents</span>
              </NavLink>
            </li>
          )} */}
          {permission_data?.client_view && (
            <li>
              <NavLink
                to="clients"
                className={activeMenu == "clients" ? "active" : ""}
                onClick={() => updateActiveStatus("clients")}
              >
                <span className="icons-wrap">
                  {/* <img
                    src="/assets/icons-svg/navIcons/cons-client.svg"
                    alt=""
                  /> */}
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12.0454 5.38965C11.8366 5.37809 11.6297 5.44642 11.4683 5.58301H11.4673C11.2826 5.73942 11.1763 5.96976 11.1763 6.21191V20.6826C11.1765 21.1367 11.5452 21.5056 11.9995 21.5059C12.4542 21.5059 12.8235 21.1369 12.8237 20.6826V7.18359L19.8589 8.35547V19.8584H14.894C14.4394 19.8584 14.0708 20.2282 14.0708 20.6826C14.071 21.1369 14.4395 21.5059 14.894 21.5059H20.6821C21.137 21.5059 21.5052 21.1373 21.5054 20.6826V7.65918C21.5054 7.25686 21.2148 6.91315 20.8179 6.84668L12.1353 5.39941L12.0454 5.38965Z" fill="#5786CC" stroke="#5786CC" stroke-width="0.2" />
                    <path d="M14.8938 16.2415C14.4391 16.2417 14.0706 16.6099 14.0706 17.0647V20.6819C14.0706 21.1367 14.439 21.5058 14.8938 21.5061H17.7883C18.2434 21.5061 18.6116 21.1368 18.6116 20.6819V17.0647C18.6116 16.6097 18.2434 16.2415 17.7883 16.2415H14.8938ZM16.9651 19.8586H15.718V17.8879H16.9651V19.8586Z" fill="#5786CC" stroke="#5786CC" stroke-width="0.2" />
                    <path d="M6.2124 16.2415L6.12744 16.2454C5.71227 16.2877 5.38818 16.6383 5.38818 17.0647V20.6819C5.38818 21.1368 5.75745 21.5061 6.2124 21.5061H9.10596C9.56093 21.5061 9.9292 21.1368 9.9292 20.6819V17.0647C9.9292 16.6097 9.56091 16.2415 9.10596 16.2415H6.2124ZM8.28271 19.8586H7.03564V17.8879H8.28271V19.8586Z" fill="#5786CC" stroke="#5786CC" stroke-width="0.2" />
                    <path d="M3.36353 2.49536C3.1546 2.48395 2.94694 2.55248 2.7854 2.6897H2.78638C2.60187 2.84616 2.49438 3.07549 2.49438 3.31763V20.6819C2.49438 21.1362 2.86386 21.5061 3.3186 21.5061C3.77309 21.5059 4.14185 21.1361 4.14185 20.6819V4.28833L11.177 5.46118V19.8586H6.21216C5.75762 19.8587 5.38904 20.2277 5.38892 20.6819C5.38892 21.1362 5.75754 21.5051 6.21216 21.5051H12.0002C12.4553 21.5051 12.8235 21.1367 12.8235 20.6819V4.76489C12.8235 4.36231 12.5329 4.01868 12.136 3.95239L3.45337 2.50513L3.36353 2.49536Z" fill="#5786CC" stroke="#5786CC" stroke-width="0.2" />
                    <path d="M17.427 12.6238L17.3333 12.6326C17.1232 12.6757 16.9653 12.862 16.9651 13.0847V13.8083C16.9651 14.0632 17.1721 14.2703 17.427 14.2703H18.1506C18.4054 14.27 18.6116 14.063 18.6116 13.8083V13.0847L18.6028 12.9919C18.5597 12.7818 18.3735 12.624 18.1506 12.6238H17.427Z" fill="#5786CC" stroke="#5786CC" stroke-width="0.2" />
                    <path d="M14.533 12.6238C14.2781 12.6238 14.0713 12.83 14.071 13.0847V13.8083C14.071 14.0632 14.278 14.2703 14.533 14.2703H15.2566C15.5114 14.27 15.7175 14.063 15.7175 13.8083V13.0847L15.7087 12.9919C15.6656 12.7818 15.4794 12.624 15.2566 12.6238H14.533Z" fill="#5786CC" stroke="#5786CC" stroke-width="0.2" />
                    <path d="M14.533 9.72949C14.2781 9.72949 14.0713 9.93582 14.071 10.1904V10.9141C14.071 11.1689 14.278 11.376 14.533 11.376H15.2566C15.5114 11.3757 15.7175 11.1687 15.7175 10.9141V10.1904C15.7173 9.93596 15.5112 9.72974 15.2566 9.72949H14.533Z" fill="#5786CC" stroke="#5786CC" stroke-width="0.2" />
                    <path d="M17.427 9.72949L17.3333 9.73828C17.1232 9.78146 16.9653 9.96778 16.9651 10.1904V10.9141C16.9651 11.1689 17.1721 11.376 17.427 11.376H18.1506C18.4054 11.3757 18.6116 11.1687 18.6116 10.9141V10.1904C18.6113 9.93596 18.4053 9.72974 18.1506 9.72949H17.427Z" fill="#5786CC" stroke="#5786CC" stroke-width="0.2" />
                    <path d="M8.74463 12.6238L8.65088 12.6326C8.44081 12.6758 8.28294 12.862 8.28271 13.0847V13.8083C8.28271 14.0632 8.48964 14.2703 8.74463 14.2703H9.46826C9.72301 14.2701 9.9292 14.063 9.9292 13.8083V13.0847L9.92041 12.9919C9.87731 12.7817 9.69107 12.6239 9.46826 12.6238H8.74463Z" fill="#5786CC" stroke="#5786CC" stroke-width="0.2" />
                    <path d="M5.85034 12.6238C5.59552 12.6238 5.38868 12.83 5.38843 13.0847V13.8083C5.38843 14.0632 5.59535 14.2703 5.85034 14.2703H6.57397C6.82862 14.27 7.03491 14.063 7.03491 13.8083V13.0847L7.02612 12.9919C6.983 12.7817 6.79669 12.624 6.57397 12.6238H5.85034Z" fill="#5786CC" stroke="#5786CC" stroke-width="0.2" />
                    <path d="M5.85034 9.72949C5.59549 9.72949 5.38868 9.93582 5.38843 10.1904V10.9141C5.38843 11.1689 5.59536 11.376 5.85034 11.376H6.57397C6.82862 11.3757 7.03491 11.1688 7.03491 10.9141V10.1904C7.03466 9.93594 6.82845 9.72974 6.57397 9.72949H5.85034Z" fill="#5786CC" stroke="#5786CC" stroke-width="0.2" />
                    <path d="M8.74463 9.72949L8.65088 9.73828C8.4408 9.78149 8.28294 9.9678 8.28271 10.1904V10.9141C8.28271 11.1689 8.48964 11.376 8.74463 11.376H9.46826C9.72301 11.3758 9.9292 11.1688 9.9292 10.9141V10.1904C9.92895 9.93594 9.72284 9.72968 9.46826 9.72949H8.74463Z" fill="#5786CC" stroke="#5786CC" stroke-width="0.2" />
                    <path d="M8.74463 6.83545L8.65088 6.84424C8.4408 6.88745 8.28293 7.07375 8.28271 7.29639V8.02002C8.28271 8.275 8.48966 8.48193 8.74463 8.48193H9.46826C9.72299 8.48175 9.9292 8.27485 9.9292 8.02002V7.29639C9.92895 7.0419 9.72284 6.83563 9.46826 6.83545H8.74463Z" fill="#5786CC" stroke="#5786CC" stroke-width="0.2" />
                    <path d="M5.85034 6.83545C5.59549 6.83545 5.38868 7.04178 5.38843 7.29639V8.02002C5.38843 8.275 5.59538 8.48193 5.85034 8.48193H6.57397C6.8286 8.48168 7.03491 8.27485 7.03491 8.02002V7.29639C7.03466 7.04189 6.82845 6.8357 6.57397 6.83545H5.85034Z" fill="#5786CC" stroke="#5786CC" stroke-width="0.2" />
                  </svg>
                </span>
                <span className="text-wrap">Clients</span>
              </NavLink>
            </li>
          )}

          {permission_data?.workers_view && (
            <li>
              <NavLink
                to="workers"
                className={activeMenu == "workers" ? "active" : ""}
                onClick={() => updateActiveStatus("workers")}
              >
                <span className="icons-wrap">
                  <img
                    src="/assets/icons-svg/navIcons/cons-worker.svg"
                    alt=""
                  />
                </span>
                <span className="text-wrap">Workers</span>
              </NavLink>
            </li>
          )}
          {permission_data?.messages_view && (
            <li>
              <NavLink
                to="messages"
                className={activeMenu == "messages" ? "active" : ""}
                onClick={() => updateActiveStatus("messages")}
              >
                <span className="icons-wrap">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2 7L10.1649 12.7154C10.8261 13.1783 11.1567 13.4097 11.5163 13.4993C11.8339 13.5785 12.1661 13.5785 12.4837 13.4993C12.8433 13.4097 13.1739 13.1783 13.8351 12.7154L22 7M6.8 20H17.2C18.8802 20 19.7202 20 20.362 19.673C20.9265 19.3854 21.3854 18.9265 21.673 18.362C22 17.7202 22 16.8802 22 15.2V8.8C22 7.11984 22 6.27976 21.673 5.63803C21.3854 5.07354 20.9265 4.6146 20.362 4.32698C19.7202 4 18.8802 4 17.2 4H6.8C5.11984 4 4.27976 4 3.63803 4.32698C3.07354 4.6146 2.6146 5.07354 2.32698 5.63803C2 6.27976 2 7.11984 2 8.8V15.2C2 16.8802 2 17.7202 2.32698 18.362C2.6146 18.9265 3.07354 19.3854 3.63803 19.673C4.27976 20 5.11984 20 6.8 20Z"
                      stroke="#5786CC"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
                <span className="text-wrap">Messages</span>
              </NavLink>
            </li>
          )}
          {permission_data?.notes_view && (
            <li>
              <NavLink
                to="notes"
                className={activeMenu == "notes" ? "active" : ""}
                onClick={() => updateActiveStatus("notes")}
              >
                {/* <span className="icons-wrap">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2 7L10.1649 12.7154C10.8261 13.1783 11.1567 13.4097 11.5163 13.4993C11.8339 13.5785 12.1661 13.5785 12.4837 13.4993C12.8433 13.4097 13.1739 13.1783 13.8351 12.7154L22 7M6.8 20H17.2C18.8802 20 19.7202 20 20.362 19.673C20.9265 19.3854 21.3854 18.9265 21.673 18.362C22 17.7202 22 16.8802 22 15.2V8.8C22 7.11984 22 6.27976 21.673 5.63803C21.3854 5.07354 20.9265 4.6146 20.362 4.32698C19.7202 4 18.8802 4 17.2 4H6.8C5.11984 4 4.27976 4 3.63803 4.32698C3.07354 4.6146 2.6146 5.07354 2.32698 5.63803C2 6.27976 2 7.11984 2 8.8V15.2C2 16.8802 2 17.7202 2.32698 18.362C2.6146 18.9265 3.07354 19.3854 3.63803 19.673C4.27976 20 5.11984 20 6.8 20Z"
                      stroke="#5786CC"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span> */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 20 19"
                  fill="none"
                >
                  <path
                    d="M9.16669 2.78828H5.66669C4.26656 2.78828 3.56649 2.78828 3.03171 3.06076C2.56131 3.30044 2.17885 3.68289 1.93917 4.1533C1.66669 4.68808 1.66669 5.38814 1.66669 6.78828V13.7883C1.66669 15.1884 1.66669 15.8885 1.93917 16.4233C2.17885 16.8937 2.56131 17.2761 3.03171 17.5158C3.56649 17.7883 4.26656 17.7883 5.66669 17.7883H12.6667C14.0668 17.7883 14.7669 17.7883 15.3017 17.5158C15.7721 17.2761 16.1545 16.8937 16.3942 16.4233C16.6667 15.8885 16.6667 15.1884 16.6667 13.7883V10.2883M6.66666 12.7883H8.06212C8.46977 12.7883 8.67359 12.7883 8.86541 12.7422C9.03547 12.7014 9.19804 12.6341 9.34716 12.5427C9.51536 12.4396 9.65948 12.2955 9.94773 12.0072L17.9167 4.03828C18.607 3.34792 18.607 2.22863 17.9167 1.53828C17.2263 0.847919 16.107 0.847919 15.4167 1.53827L7.44772 9.50723C7.15946 9.79548 7.01534 9.93961 6.91227 10.1078C6.82088 10.2569 6.75354 10.4195 6.71271 10.5896C6.66666 10.7814 6.66666 10.9852 6.66666 11.3928V12.7883Z"
                    stroke="#5786CC"
                    stroke-width="1.66667"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <span className="text-wrap">Notes</span>
              </NavLink>
            </li>
          )}

          {/* {permission_data.invoices_view && (
            <li>
              <NavLink
                to="invoices"
                className={activeMenu == "invoices" ? "active" : ""}
                onClick={() => updateActiveStatus("invoices")}
              >
                <span className="icons-wrap">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M14 11H8M10 15H8M16 7H8M20 6.8V17.2C20 18.8802 20 19.7202 19.673 20.362C19.3854 20.9265 18.9265 21.3854 18.362 21.673C17.7202 22 16.8802 22 15.2 22H8.8C7.11984 22 6.27976 22 5.63803 21.673C5.07354 21.3854 4.6146 20.9265 4.32698 20.362C4 19.7202 4 18.8802 4 17.2V6.8C4 5.11984 4 4.27976 4.32698 3.63803C4.6146 3.07354 5.07354 2.6146 5.63803 2.32698C6.27976 2 7.11984 2 8.8 2H15.2C16.8802 2 17.7202 2 18.362 2.32698C18.9265 2.6146 19.3854 3.07354 19.673 3.63803C20 4.27976 20 5.11984 20 6.8Z"
                      stroke="#5786CC"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
                <span className="text-wrap">Invoices</span>
              </NavLink>
            </li>
          )} */}
          {permission_data?.reporting_view && (
            <li>
              <NavLink
                to="reports"
                className={activeMenu == "reporting" ? "active" : ""}
                onClick={() => updateActiveStatus("reporting")}
              >
                <span className="icons-wrap">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M21 9L14.5515 13.6061C14.3555 13.746 14.2576 13.816 14.1527 13.8371C14.0602 13.8557 13.9643 13.8478 13.8762 13.8142C13.7762 13.7762 13.691 13.691 13.5208 13.5208L10.4792 10.4792C10.309 10.309 10.2238 10.2238 10.1238 10.1858C10.0357 10.1522 9.9398 10.1443 9.84732 10.1629C9.74241 10.184 9.64445 10.254 9.44853 10.3939L3 15M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z"
                      stroke="#5786CC"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
                <span className="text-wrap">Reporting</span>
              </NavLink>
            </li>
          )}

          {permission_data?.users_view && (
            <li>
              <NavLink
                to="users"
                className={activeMenu == "users" ? "active" : ""}
                onClick={() => updateActiveStatus("users")}
              >
                <span className="icons-wrap">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M19 21V15M16 18H22M12 15H8C6.13623 15 5.20435 15 4.46927 15.3045C3.48915 15.7105 2.71046 16.4892 2.30448 17.4693C2 18.2044 2 19.1362 2 21M15.5 3.29076C16.9659 3.88415 18 5.32131 18 7C18 8.67869 16.9659 10.1159 15.5 10.7092M13.5 7C13.5 9.20914 11.7091 11 9.5 11C7.29086 11 5.5 9.20914 5.5 7C5.5 4.79086 7.29086 3 9.5 3C11.7091 3 13.5 4.79086 13.5 7Z"
                      stroke="#5786CC"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
                <span className="text-wrap">Users</span>
              </NavLink>
            </li>
          )}

          {permission_data?.contacts_view && (
            <li>
              <NavLink
                to="contacts"
                className={activeMenu == "contacts" ? "active" : ""}
                onClick={() => updateActiveStatus("contacts")}
              >
                <span className="icons-wrap">
                  {/* <img src="/assets/icons-svg/navIcons/contacts.png" alt="" /> */}
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M17.7412 3.1792C18.4645 3.17923 19.1584 3.46665 19.6699 3.97803L19.8506 4.17822C20.2484 4.66354 20.4687 5.27377 20.4688 5.90674V18.8423C20.4686 19.4752 20.2484 20.0855 19.8506 20.5708L19.6699 20.771C19.1584 21.2824 18.4645 21.5698 17.7412 21.5698H7.29004C6.65713 21.5698 6.04684 21.3493 5.56152 20.9517L5.36133 20.771C4.84993 20.2596 4.56263 19.5655 4.5625 18.8423V17.7964H4.38477C4.11807 17.7964 3.8691 17.6722 3.70898 17.4644L3.64551 17.3706C3.49307 17.1067 3.49309 16.781 3.64551 16.5171L3.70898 16.4233C3.8691 16.2154 4.11807 16.0913 4.38477 16.0913L4.5625 16.0903V13.2271H4.38477C4.11808 13.2271 3.8691 13.1029 3.70898 12.895L3.64551 12.8013C3.49307 12.5374 3.4931 12.2116 3.64551 11.9478L3.70898 11.854C3.8691 11.6461 4.11806 11.522 4.38477 11.522H4.5625V8.65771H4.38477C4.11807 8.65771 3.8691 8.53358 3.70898 8.32568L3.64551 8.23193C3.49307 7.96805 3.49308 7.64231 3.64551 7.37842L3.70898 7.28467C3.8691 7.07675 4.11807 6.95264 4.38477 6.95264H4.5625V5.90674C4.56261 5.18351 4.84992 4.48944 5.36133 3.97803L5.56152 3.79736C6.04685 3.39969 6.65712 3.17925 7.29004 3.1792H17.7412ZM7.29004 4.88525C7.01918 4.88531 6.75983 4.99357 6.56836 5.18506H6.56738C6.37612 5.37645 6.26867 5.63609 6.26855 5.90674V6.95264H6.30566C6.61041 6.95264 6.89249 7.11466 7.04492 7.37842L7.09473 7.47998C7.18058 7.68812 7.18058 7.92223 7.09473 8.13037L7.04492 8.23193C6.91152 8.46276 6.67911 8.61619 6.41895 8.65088L6.30566 8.65771H6.26855V11.522H6.54004C6.84481 11.522 7.12687 11.684 7.2793 11.9478L7.3291 12.0493C7.41494 12.2574 7.41495 12.4916 7.3291 12.6997L7.2793 12.8013C7.1459 13.0321 6.91347 13.1855 6.65332 13.2202L6.54004 13.2271H6.26855V16.0913H6.54004C6.8448 16.0913 7.12687 16.2533 7.2793 16.5171L7.3291 16.6187C7.41495 16.8268 7.41495 17.0609 7.3291 17.269L7.2793 17.3706C7.1459 17.6014 6.91348 17.7548 6.65332 17.7896L6.54004 17.7964H6.26855V18.8423C6.26867 19.1129 6.37612 19.3726 6.56738 19.564H6.56836L6.64258 19.6323C6.82428 19.7813 7.05299 19.8637 7.29004 19.8638H17.7412C18.0122 19.8637 18.2724 19.7555 18.4639 19.564L18.5312 19.4897C18.6803 19.3081 18.7626 19.0794 18.7627 18.8423V5.90674C18.7626 5.66964 18.6803 5.44097 18.5312 5.25928L18.4639 5.18506C18.2724 4.99349 18.0122 4.88528 17.7412 4.88525H7.29004Z" fill="#5786CC" stroke="#5786CC" stroke-width="0.3" />
                    <path d="M12.6834 12.3746C13.8463 12.3746 14.7891 11.4319 14.7891 10.269C14.7891 9.10606 13.8463 8.16333 12.6834 8.16333C11.5205 8.16333 10.5778 9.10606 10.5778 10.269C10.5778 11.4319 11.5205 12.3746 12.6834 12.3746Z" stroke="#5786CC" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                    <path d="M12.6834 13.7784C11.3589 13.7784 10.1817 14.5011 9.43569 15.6212C9.27226 15.8666 9.19054 15.9893 9.19995 16.146C9.20727 16.2681 9.28727 16.4175 9.38478 16.4912C9.51001 16.5859 9.68225 16.5859 10.0267 16.5859H15.3401C15.6846 16.5859 15.8568 16.5859 15.9821 16.4912C16.0796 16.4175 16.1596 16.2681 16.1669 16.146C16.1763 15.9893 16.0946 15.8666 15.9312 15.6212C15.1851 14.5011 14.0079 13.7784 12.6834 13.7784Z" stroke="#5786CC" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>

                </span>
                <span className="text-wrap">Contacts</span>
              </NavLink>
            </li>
          )}
        </ul>

        <div className="mt-auto">
          <ul>
            {permission_data?.support_view && (
              <li>
                <NavLink
                  to="support"
                  className={activeMenu == "support" ? "active" : ""}
                  onClick={() => updateActiveStatus("support")}
                >
                  <span className="icons-wrap">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M21 18V12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12V18M5.5 21C4.11929 21 3 19.8807 3 18.5V16.5C3 15.1193 4.11929 14 5.5 14C6.88071 14 8 15.1193 8 16.5V18.5C8 19.8807 6.88071 21 5.5 21ZM18.5 21C17.1193 21 16 19.8807 16 18.5V16.5C16 15.1193 17.1193 14 18.5 14C19.8807 14 21 15.1193 21 16.5V18.5C21 19.8807 19.8807 21 18.5 21Z"
                        stroke="#5786CC"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </span>
                  <span className="text-wrap">Support</span>
                </NavLink>
              </li>
            )}

            {permission_data?.settings_view && (
              <li>
                <NavLink
                  to="settings"
                  className={activeMenu == "settings" ? "active" : ""}
                  onClick={() => updateActiveStatus("settings")}
                >
                  <span className="icons-wrap">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
                        stroke="#5786CC"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M18.7273 14.7273C18.6063 15.0015 18.5702 15.3056 18.6236 15.6005C18.6771 15.8954 18.8177 16.1676 19.0273 16.3818L19.0818 16.4364C19.2509 16.6052 19.385 16.8057 19.4765 17.0265C19.568 17.2472 19.6151 17.4838 19.6151 17.7227C19.6151 17.9617 19.568 18.1983 19.4765 18.419C19.385 18.6397 19.2509 18.8402 19.0818 19.0091C18.913 19.1781 18.7124 19.3122 18.4917 19.4037C18.271 19.4952 18.0344 19.5423 17.7955 19.5423C17.5565 19.5423 17.3199 19.4952 17.0992 19.4037C16.8785 19.3122 16.678 19.1781 16.5091 19.0091L16.4545 18.9545C16.2403 18.745 15.9682 18.6044 15.6733 18.5509C15.3784 18.4974 15.0742 18.5335 14.8 18.6545C14.5311 18.7698 14.3018 18.9611 14.1403 19.205C13.9788 19.4489 13.8921 19.7347 13.8909 20.0273V20.1818C13.8909 20.664 13.6994 21.1265 13.3584 21.4675C13.0174 21.8084 12.5549 22 12.0727 22C11.5905 22 11.1281 21.8084 10.7871 21.4675C10.4461 21.1265 10.2545 20.664 10.2545 20.1818V20.1C10.2475 19.7991 10.1501 19.5073 9.97501 19.2625C9.79991 19.0176 9.55521 18.8312 9.27273 18.7273C8.99853 18.6063 8.69437 18.5702 8.39947 18.6236C8.10456 18.6771 7.83244 18.8177 7.61818 19.0273L7.56364 19.0818C7.39478 19.2509 7.19425 19.385 6.97353 19.4765C6.7528 19.568 6.51621 19.6151 6.27727 19.6151C6.03834 19.6151 5.80174 19.568 5.58102 19.4765C5.36029 19.385 5.15977 19.2509 4.99091 19.0818C4.82186 18.913 4.68775 18.7124 4.59626 18.4917C4.50476 18.271 4.45766 18.0344 4.45766 17.7955C4.45766 17.5565 4.50476 17.3199 4.59626 17.0992C4.68775 16.8785 4.82186 16.678 4.99091 16.5091L5.04545 16.4545C5.25503 16.2403 5.39562 15.9682 5.4491 15.6733C5.50257 15.3784 5.46647 15.0742 5.34545 14.8C5.23022 14.5311 5.03887 14.3018 4.79497 14.1403C4.55107 13.9788 4.26526 13.8921 3.97273 13.8909H3.81818C3.33597 13.8909 2.87351 13.6994 2.53253 13.3584C2.19156 13.0174 2 12.5549 2 12.0727C2 11.5905 2.19156 11.1281 2.53253 10.7871C2.87351 10.4461 3.33597 10.2545 3.81818 10.2545H3.9C4.2009 10.2475 4.49273 10.1501 4.73754 9.97501C4.98236 9.79991 5.16883 9.55521 5.27273 9.27273C5.39374 8.99853 5.42984 8.69437 5.37637 8.39947C5.3229 8.10456 5.18231 7.83244 4.97273 7.61818L4.91818 7.56364C4.74913 7.39478 4.61503 7.19425 4.52353 6.97353C4.43203 6.7528 4.38493 6.51621 4.38493 6.27727C4.38493 6.03834 4.43203 5.80174 4.52353 5.58102C4.61503 5.36029 4.74913 5.15977 4.91818 4.99091C5.08704 4.82186 5.28757 4.68775 5.50829 4.59626C5.72901 4.50476 5.96561 4.45766 6.20455 4.45766C6.44348 4.45766 6.68008 4.50476 6.9008 4.59626C7.12152 4.68775 7.32205 4.82186 7.49091 4.99091L7.54545 5.04545C7.75971 5.25503 8.03183 5.39562 8.32674 5.4491C8.62164 5.50257 8.9258 5.46647 9.2 5.34545H9.27273C9.54161 5.23022 9.77093 5.03887 9.93245 4.79497C10.094 4.55107 10.1807 4.26526 10.1818 3.97273V3.81818C10.1818 3.33597 10.3734 2.87351 10.7144 2.53253C11.0553 2.19156 11.5178 2 12 2C12.4822 2 12.9447 2.19156 13.2856 2.53253C13.6266 2.87351 13.8182 3.33597 13.8182 3.81818V3.9C13.8193 4.19253 13.906 4.47834 14.0676 4.72224C14.2291 4.96614 14.4584 5.15749 14.7273 5.27273C15.0015 5.39374 15.3056 5.42984 15.6005 5.37637C15.8954 5.3229 16.1676 5.18231 16.3818 4.97273L16.4364 4.91818C16.6052 4.74913 16.8057 4.61503 17.0265 4.52353C17.2472 4.43203 17.4838 4.38493 17.7227 4.38493C17.9617 4.38493 18.1983 4.43203 18.419 4.52353C18.6397 4.61503 18.8402 4.74913 19.0091 4.91818C19.1781 5.08704 19.3122 5.28757 19.4037 5.50829C19.4952 5.72901 19.5423 5.96561 19.5423 6.20455C19.5423 6.44348 19.4952 6.68008 19.4037 6.9008C19.3122 7.12152 19.1781 7.32205 19.0091 7.49091L18.9545 7.54545C18.745 7.75971 18.6044 8.03183 18.5509 8.32674C18.4974 8.62164 18.5335 8.9258 18.6545 9.2V9.27273C18.7698 9.54161 18.9611 9.77093 19.205 9.93245C19.4489 10.094 19.7347 10.1807 20.0273 10.1818H20.1818C20.664 10.1818 21.1265 10.3734 21.4675 10.7144C21.8084 11.0553 22 11.5178 22 12C22 12.4822 21.8084 12.9447 21.4675 13.2856C21.1265 13.6266 20.664 13.8182 20.1818 13.8182H20.1C19.8075 13.8193 19.5217 13.906 19.2778 14.0676C19.0339 14.2291 18.8425 14.4584 18.7273 14.7273Z"
                        stroke="#5786CC"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </span>
                  <span className="text-wrap">Settings</span>
                </NavLink>
              </li>
            )}
            <li>
              <hr />
            </li>
            <li>
              <LogoutUser logOut={"client"} SetAlign={true} />
            </li>
          </ul>
        </div>
      </div>
    </React.Fragment>
  );
};
export default ContractorPortalSideNav;
